export default __webpack_public_path__ + "static/media/monnal-t75.a34bbfbe.jpg";